export default "/imgs/initiatives-list.png"